module.exports = __webpack_public_path__ + "static/media/padding-area-right.b43f2b7e.svg";